import { z } from 'zod';
export const PickerSuggestionEntityTypeSchema = z.enum([
    'system',
    'user',
    'artifact',
    'orgFunction',
    'externalContact'
]);
export const PickerSuggestionsRequestSchema = z.object({
    entityType: PickerSuggestionEntityTypeSchema,
    processId: z.string().optional(),
    recordingId: z.string().optional(),
    recentlyUsedLimit: z.coerce.number().int().positive().max(50).optional(),
    bucketLimit: z.coerce.number().int().positive().max(50).optional()
});
const ItemWithStatsSchema = z.object({
    _id: z.string(),
    occurrences: z.number().int().nonnegative(),
    samples: z.number().int().nonnegative(),
    recommended: z.boolean().optional()
});
const RecentlyUsedItemSchema = z.object({
    _id: z.string(),
    lastUsedAt: z.string()
});
const RoleBucketSchema = z.object({
    roleId: z.string().nullable(),
    roleName: z.string().nullable(),
    peerCount: z.number().int().nonnegative(),
    items: z.array(ItemWithStatsSchema)
});
const ProcessBucketSchema = z.object({
    processId: z.string(),
    processName: z.string(),
    sampleSize: z.number().int().nonnegative(),
    items: z.array(ItemWithStatsSchema)
});
const DepartmentBucketSchema = z.object({
    departmentId: z.string().nullable(),
    departmentName: z.string().nullable(),
    peerCount: z.number().int().nonnegative(),
    items: z.array(ItemWithStatsSchema)
});
const TypeBucketSchema = z.object({
    type: z.string(),
    items: z.array(ItemWithStatsSchema)
});
export const PickerSuggestionsResponseSchema = z.object({
    data: z.object({
        recentlyUsed: z.array(RecentlyUsedItemSchema),
        role: RoleBucketSchema.nullable(),
        process: ProcessBucketSchema.nullable(),
        department: DepartmentBucketSchema.nullable(),
        type: TypeBucketSchema.nullable()
    })
});

//# sourceMappingURL=picker-suggestions.schema.js.map